import { useEffect, useState } from "react";

import CheckoutReviewVendorOrderSectionFooter from "@/app/checkout/(squeeze)/review/checkoutReviewVendorOrderSectionFooter";
import { CheckoutOrder } from "@/fetch/getCheckoutResponse";

import CheckoutReviewVendorOrderItemSection from "@/app/checkout/(squeeze)/review/checkoutReviewVendorOrderItemSection";
import CheckoutReviewVendorOrderSectionHeader from "@/app/checkout/(squeeze)/review/checkoutReviewVendorOrderSectionHeader";
import VendorHeader from "@/app/checkout/(squeeze)/review/twoDayDeliveryExperience/vendorHeader";

import style from "../checkoutReviewVendorOrderSection.module.scss";

export default function VendorOrderSection({
  vendorOrder,
  isConfirmationPage,
}: {
  vendorOrder: CheckoutOrder;
  isConfirmationPage: boolean;
}) {
  const [twoDayDeliveryProducts, setTwoDayDeliveryProducts] = useState<Array<ShoppingCartVendorOrderProduct>>([]);
  const [standardDeliveryProducts, setStandardDeliveryProducts] = useState<Array<ShoppingCartVendorOrderProduct>>([]);

  useEffect(() => {
    if (vendorOrder) {
      const twoDayDeliveryProducts = vendorOrder?.products?.filter((product) => product?.twoDayDeliverySw);
      const standardDeliveryProducts = vendorOrder?.products?.filter((product) => !product?.twoDayDeliverySw);

      setTwoDayDeliveryProducts(twoDayDeliveryProducts);
      setStandardDeliveryProducts(standardDeliveryProducts);
    }
  }, [vendorOrder]);

  return (
    <div className={style["vendor-order-section-container"]}>
      <section>
        <div className={style["vendor-order-section-flex"]}>
          {vendorOrder && twoDayDeliveryProducts && (
            <VendorHeader
              vendorName={vendorOrder?.vendorName}
              deliveryDate={vendorOrder?.vendorDeliveryDates?.twoDayDeliveryDate}
              isConfirmationPage={isConfirmationPage}
            />
          )}
          {twoDayDeliveryProducts?.map((product, index) => (
            <CheckoutReviewVendorOrderItemSection
              key={index}
              product={product}
              isConfirmationPage={isConfirmationPage}
            />
          ))}
          {vendorOrder && standardDeliveryProducts?.length > 0 && (
            <CheckoutReviewVendorOrderSectionHeader shoppingCartVendorOrder={vendorOrder} />
          )}
          {standardDeliveryProducts?.map((product, index) => (
            <CheckoutReviewVendorOrderItemSection
              key={index}
              product={product}
              isConfirmationPage={isConfirmationPage}
            />
          ))}
          {vendorOrder && standardDeliveryProducts && (
            <CheckoutReviewVendorOrderSectionFooter shoppingCartVendorOrder={vendorOrder} />
          )}
        </div>
      </section>
    </div>
  );
}
